import side from './side'
import back from './back'
import top from './top'
import palm from './palm'
import {
  camoBrownGreen,
  camoGrey,
  camoOrange,
  camoRed,
  camoTan,
  fadeGreenGrey,
  fadePurple,
  fadeRedNavy,
  fadeSunset,
  skyBlue,
  skyGrey,
  skyPink,
  skyRed,
  galaxyBlue,
  galaxyPink,
  galaxyTeal,
  snakeBlue,
  snakeGreen,
  snakeTan,
  speckleBlackWhite,
  speckleMulti,
  speckleTanBlack,
  speckleTanPink,
  oregonOption1,
  oregonOption2,
  oregonOption3,
  oregonOption4,
  oregonOption5,
  oregonOption6,
  oregonOption7,
  oregonOption8,
  oregonOption9,
  oregonOption10,
  oklahomaOption1,
  oklahomaOption2,
  oklahomaOption3,
  oklahomaOption4,
  oklahomaOption5,
  oklahomaOption6,
  texasOption1,
  texasOption2,
  texasOption3,
  texasOption4,
  texasOption5,
  texasOption6,
} from './patterns'

const views = [
  {
    id: 'side',
    name: 'Side of Hand',
    iconName: 'topOfHand',
    productAssets: side,
    productItems: [],
    reRender: 0,
    viewProps: {
      rotation: 90,
      offset: {
        x: -1000,
      },
    },
    thumbnail: true,
  },
  {
    id: 'back',
    name: 'Back of Hand',
    iconName: 'palmOfHand',
    productAssets: back,
    productItems: [],
    reRender: 0,
    viewProps: {
      rotation: -98,
      scale: 0.95,
    },
  },
  {
    id: 'top',
    name: 'Top of Hand',
    iconName: 'topOfHand',
    productAssets: top,
    productItems: [],
    reRender: 0,
    viewProps: {
      rotation: -15,
      scale: 0.85,
      offset: {
        x: -50,
      },
    },
  },
  {
    id: 'palm',
    name: 'Palm of Hand',
    iconName: 'palmOfHand',
    productAssets: palm,
    productItems: [],
    reRender: 0,
    viewProps: {
      flipX: true,
    },
  },
]

const tabs = [
  {
    id: 1,
    name: 'Side of Hand',
    athleteName: 'Web',
    prefix: '',
    iconName: 'topOfHand',
    iconStyles: 'transform: rotate(90deg)',
    views: [views[0]],
  },
  {
    id: 2,
    name: 'Back of Hand',
    athleteName: 'Shell',
    prefix: '',
    iconName: 'topOfHand',
    iconStyles: 'transform: rotate(-90deg)',
    views: [views[1]],
  },
  {
    id: 3,
    name: 'Top of Hand',
    athleteName: 'Top',
    prefix: '',
    iconName: 'topOfHand',
    views: [views[2]],
  },
  {
    id: 4,
    name: 'Palm of Hand',
    athleteName: 'Palm',
    prefix: '',
    iconName: 'palmOfHand',
    views: [views[3]],
  },
]

const previewAllTabs = [
  {
    id: 0,
    name: 'Preview All',
    prefix: 'preview',
    iconName: '',
    views: [views[0], views[1], views[2], views[3]],
    styleProps: [
      { width: '50%', height: '45%' },
      { width: '50%', height: '45%' },
      { width: '50%', height: '55%' },
      { width: '50%', height: '55%' },
    ],
    aspectRatio: {
      x: 6.5,
      y: 5,
    },
  },
  ...tabs,
]

const webs = [
  { name: 'H-Web', value: 'H', positions: ['Infield', 'Outfield'] },
  { name: 'I-Web', value: 'I', positions: ['Infield'] },
  { name: 'Mod Bar', value: 'Mod Bar', positions: ['Pitcher'] },
  { name: 'P-Web', value: 'P', positions: ['Pitcher'] },
  { name: 'Single Post', value: 'Single Post', positions: ['Infield'] },
  { name: 'Snake Eyes', value: 'Snake Eyes', positions: ['Infield'] },
  {
    name: 'Trapeze',
    value: 'Trap',
    positions: ['Outfield'],
  },
  { name: 'X-Web', value: 'X', positions: [] },
  { name: 'Mod Single Post', value: 'Mod Single Post', positions: [] },
]

const fonts = [
  {
    label: 'Script',
    value: 'Flamboyan',
  },
  {
    label: 'Block',
    value: 'Futura',
  },
]

const patterns = {
  camoBrownGreen,
  camoGrey,
  camoOrange,
  camoRed,
  camoTan,
  fadeGreenGrey,
  fadePurple,
  fadeRedNavy,
  fadeSunset,
  skyBlue,
  skyGrey,
  skyPink,
  skyRed,
  galaxyBlue,
  galaxyPink,
  galaxyTeal,
  snakeBlue,
  snakeGreen,
  snakeTan,
  speckleBlackWhite,
  speckleMulti,
  speckleTanBlack,
  speckleTanPink,
  oregonOption1,
  oregonOption2,
  oregonOption3,
  oregonOption4,
  oregonOption5,
  oregonOption6,
  oregonOption7,
  oregonOption8,
  oregonOption9,
  oregonOption10,
  oklahomaOption1,
  oklahomaOption2,
  oklahomaOption3,
  oklahomaOption4,
  oklahomaOption5,
  oklahomaOption6,
  texasOption1,
  texasOption2,
  texasOption3,
  texasOption4,
  texasOption5,
  texasOption6,
}

export const config = {
  views,
  tabs,
  previewAllTabs,
  webs,
  fonts,
  patterns,
}

const data = {
  config,
  side,
  back,
  top,
  palm,
}

export default data
